import React, { useEffect, useState } from "react";
import { BookingEngine } from "../../../hotel_integration_modules/index";
import { langHash } from "../../../settings/IntegrationConstants";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import JoinScreen from "./JoinScreen";
import LoginScreen from "./LoginScreen";
import PasswordScreen from "./PasswordScreen";
import ForgotPasswordScreen from "./ForgotPasswordScreen";
import GoogleAuthScreen from "./GoogleAuthScreen";
import IntroScreen from "./IntroScreen";
import EnrollmentConfirmationScreen from "./EnrollmentConfirmationScreen";
import ModalWrapper from "./ModalWrapper";
import ResetPasswordConfirmationScreen from "./ResetPasswordConfirmationScreen";

type MobileModalProps = {
  handleClose: () => void;
  existingMember: boolean;
  gbEnrollChecked: boolean;
  userLoggedIn: boolean;
  bookingEngine: BookingEngine;
  hotelSettings: any;
  locale: string;
};

const MobileModal = ({ 
  handleClose,
  existingMember,
  gbEnrollChecked,
  userLoggedIn,
  bookingEngine,
  hotelSettings,
  locale
 }: MobileModalProps) => {
  const widgetLoginEnabled = hotelSettings.widget.loginEnabled;
  const whiteLabel = hotelSettings.hotel.whiteLabel;
  const cobrandingEnabled = hotelSettings.hotel.cobrandingEnabled;
  const allBenefits = bookingEngine.hotel.benefits;
  const hotelLogoURL = hotelSettings.hotel.hotelLogoURL;

  let benefitsCorrectLanguage: any[] = [];
  let windowLanguage = document.documentElement.lang;
  if (windowLanguage.indexOf("-") !== -1) {
    windowLanguage = windowLanguage.split("-")[0];
  }

  let windowLanguageId = Object.keys(langHash)[
    Object.values(langHash).indexOf(windowLanguage)
  ];

  allBenefits.forEach((item: any) => {
    if (windowLanguageId === "2") {
      if (item.language_id === 2) {
        benefitsCorrectLanguage.push(item);
      }
    } else if (
      windowLanguageId !== "2" &&
      item.language_id === windowLanguageId
    ) {
      benefitsCorrectLanguage.push(item);
    }
  });

  type ModalScreen = "intro" | "join" | "login" | "password" | "google" | "success" | "reset_password_confirmation" | "forgot_password" | "enrollment_confirmation";

  const [activeScreen, setActiveScreen] = React.useState<ModalScreen>("intro");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("")

    useEffect(() => {
    library.add(fas);
    const storedFirstName = sessionStorage.getItem("gbFirstName");
    if (storedFirstName) {
      setFirstName(storedFirstName);
    }
  }, []);

  return (
    <ModalWrapper handleClose={handleClose} cobrandingEnabled={cobrandingEnabled} hotelLogoURL={hotelLogoURL}>
      {activeScreen === "intro" && (
      <IntroScreen
        benefitsCorrectLanguage={benefitsCorrectLanguage}
        userLoggedIn={userLoggedIn}
        widgetLoginEnabled={widgetLoginEnabled}
        onJoinClick={() => setActiveScreen("join")}
        onLoginClick={() => setActiveScreen("login")}
        firstName={firstName}
        cobrandingEnabled={cobrandingEnabled}
        whiteLabel={whiteLabel}
      />
    )}

    {activeScreen === "join" && (
      <JoinScreen
        hotelName={window.gb_data.hotel.name}
        onSuccess={() => setActiveScreen("enrollment_confirmation")}
        onLoginClick={() => setActiveScreen("login")}
        setUserData={(email) => {
          setEmail(email)
        }}
      />
    )}

    {activeScreen === "enrollment_confirmation" && (
      <EnrollmentConfirmationScreen onClose={handleClose} email={email}/>
    )}

    {activeScreen === "login" && (
      <LoginScreen
        hotelName={window.gb_data.hotel.name}
        onJoinClick={() => setActiveScreen("join")}
        onPassword={() => setActiveScreen("password")}
        onGoogle={() => setActiveScreen("google")}
        setUserData={(email, firstName) => {
          setFirstName(firstName)
          setEmail(email)
        }}
      />
    )}

    {activeScreen === "password" && (
      <PasswordScreen 
        firstName={firstName}
        email={email}
        onLoginClick={() => setActiveScreen("login")}
        onForgotPassword={() => setActiveScreen("forgot_password")}
        onSuccess={() => setActiveScreen("intro")}
      />
    )}

    {activeScreen === "forgot_password" && (
      <ForgotPasswordScreen 
        onLoginClick={() => setActiveScreen("login")}
        onResetPasswordConfirmation={() => setActiveScreen("reset_password_confirmation")}
      />
    )}

    {activeScreen === "reset_password_confirmation" && (
      <ResetPasswordConfirmationScreen 
        onLoginClick={() => setActiveScreen("login")} 
      />
    )}

    {activeScreen === "google" && (
      <GoogleAuthScreen         
        firstName={firstName}
        onLoginClick={() => setActiveScreen("login")}
        onSuccess={() => setActiveScreen("intro")}
      />
    )}
    </ModalWrapper>
  );
};

export default MobileModal;
